import * as mentorApi from './mentorApi';

export async function loadYear2Discovery(api = mentorApi) {
  const schools = await api.getYear2SquadSetupSchools();
  const cohortsBySchoolEntries = await Promise.all(
    (schools || []).map(async (school) => {
      const schoolId = school.school_id ?? school.schoolId ?? school.id;
      const cohorts = await api.getYear2SquadSetupCohorts(schoolId);
      return [String(schoolId), cohorts || []];
    })
  );

  return {
    schools: schools || [],
    cohortsBySchool: Object.fromEntries(cohortsBySchoolEntries),
    loadedAt: new Date().toISOString(),
  };
}
